import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { message, Switch, Form, Input, Alert, Space, Select, Tooltip } from 'antd';
import { app } from '../../config';
import getHeaders from '../../utils/authHeaders';
import getShopPartner from '../../hooks/getShopPartner';
import useFetchProducts from '../../hooks/fetchProducts';
import { UpdateRecord } from '../../layouts/UpdateRecord';
import { InputField, InputMasker, SelectField } from '../../layouts/FormFields';
import { MinusCircleOutlined } from '@ant-design/icons';

const EditShopPartner = () => {
  const [form] = Form.useForm();

  const [uploadObj, setUploadObj] = useState({});
  const [show, setShow] = useState(false);
  const [addUserResp, setAddUserResp] = useState({});
  const [successMsg, setSuccessMsg] = useState('');
  const [noinvList, setNoinvList] = useState(false);
  const [newData, setNewData] = useState();
  const [selectedProducts, setSelectedProducts] = useState([]); // Track selected product IDs

  const [apiUrl, setApiUrl] = useState({});
  const [alert, setAlert] = useState(false);
  const [apiResp, setAPIResp] = useState(false);
  const [products, setProducts] = useState([]);
  let shopPart = JSON.parse(localStorage.getItem('shopPartnerId'));
  let res = getShopPartner(shopPart.shopPartnerId);
  // console.log('res-shop---->', res);
  const [affiliateParents, setaffiliateParents] = useState([]);

  let shopPartObj = res.response ? res.response?.data : null;
  let shopPartner = res.response ? res.response?.data?.shopPartner[0] : null;
  // console.log('shopPartObj-->', shopPartObj);
  // console.log('shopPartObjId-->', shopPartner);

  let prrds;

  const fetchedProducts = useFetchProducts(setProducts);
  prrds = fetchedProducts.response ? fetchedProducts.response.data : [];
  // console.log('prrds-->', prrds);
  // console.log('fetchedProducts-->', fetchedProducts);

  const [loading, setLoading] = useState(false);
  const [resetModal] = useState(false);
  const navigate = useNavigate();

  // console.log('shopPartObj--->', shopPartObj);

  const [dummydata, setDummyData] = useState(null);
  const getaffiliateParent = async () => {
    try {
      let resp = await axios.get(`${app.URL}/api/v1/admin/affiliateparent/getparents`, { headers: getHeaders() });
      console.log('resp here is ', resp.data.result.data);
      if (resp.status == 200) {
        setaffiliateParents(resp?.data?.result?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  // console.log('apiurl ', apiUrl);
  useEffect(() => {
    getaffiliateParent();
  }, []);
  useEffect(() => {
    if (shopPartObj?.shopPartnerMappingList) {
      // const initialValues = {
      //   invList: shopPartObj.shopPartnerMappingList.map((item) => ({
      //     product: item.productId, // Set the productId for each item in the initial values
      //     url: item.url, // Set the productId for each item in the initial values
      //     commission: item.commissionPercentage,
      //     // commission: 3,
      //   })),
      // };
      const initialValues =
        shopPartObj?.shopPartnerMappingList && shopPartObj?.shopPartnerMappingList.length > 0
          ? {
              invList: shopPartObj.shopPartnerMappingList.map((item) => ({
                product: item.productId,
                url: item.url,
                commission: item.commissionPercentage,
                commissionPercentageClient: item.commissionPercentageClient,
              })),
            }
          : { invList: [{ product: null, url: '', commission: null }] };

      setDummyData(initialValues); // Update dummydata
    }
    // else {
    //   setDummyData({
    //     invList: [{ product: 1, url: '', commission: 1 }],
    //   })
    // }
  }, [shopPartObj]); // Run only when shopPartObj changes
  const initialValueaa = shopPartner?.parentId || '' // Defaults to the first affiliateParentId

  console.log('initialValues', dummydata);
  // console.log('dummydata --->', dummydata);

  const uploadData = async (uploadObj) => {
    console.log('uploadObj--->', uploadObj);
    // return
    try {

      const res = await axios.post(`${app.URL}/api/v1/admin/shoppartner/update/${shopPartner.shopPartnerId}`, uploadObj, { headers: getHeaders() });
      // const res = await axios.post(`http://localhost:3200/api/v1/admin/shoppartner/update/${shopPartner.shopPartnerId}`, uploadObj, { headers: getHeaders() });
     
      console.log('res-update----->', res);
      setShow(false);

      if (res.data.result.success) {
        const updatedData = res.data.result.data;
        // form.setFieldsValue({
        //   email: updatedData.email || '',
        //   address: updatedData.address || '',
        //   phone: updatedData.phone || '',
        // });
        setNewData(updatedData);
        message.success(res.data.result.msg);
        // setSuccessMsg(res.data.result.msg);
        setAlert(true);
      } else {
        message.warning(res.data.result.msg);
      }
    } catch (err) {
      setShow(false);
      console.error('Error updating data:', err);
      message.error('Failed to update data. Please try again.');
    }
  };

  const onFinish = (values) => {
    console.log('Success:', values);
    setUploadObj({
      email: values.email ? values.email : null,
      clientId: values.clientId ? values.clientId.trim() : null,
      parentId: values.parentId && values.parentId == shopPartner.name ? shopPartner.parentId : values.parentId,
      // phone: values.phone ? values.phone : '',
      phone: values.phone ? values.phone.split('_')[0].slice(0, 12) : '',
      address: values.address ? values.address.trim() : null,
      contactName: values.contactName ? values.contactName.trim() : null,
      affiliateName: values.affiliateName ? values.affiliateName.trim() : null,
      callbackUrl: values.callbackUrl ? values.callbackUrl.trim() : null,
      isActive: values.isActive ? values.isActive : false,
    });
    console.log('apiurl in here', apiUrl, dummydata.invList[0]?.url);
    console.log('apiurl in here', !apiUrl);
    // if (!apiUrl || dummydata.invList[0]?.url) {
    //   //  setShow(false);
    //   message.error('Kindly  Select atleast one Product');
    //   return;
    // }
    setShow(true);
  };
  // console.log(uploadObj);
  const submitData = () => {
    console.log('calling');
    if (uploadObj.phone?.split('_')[0].length < 12) {
      setShow(false);
      message.error('Mobile number should be at least 10 characters long');
      return
    }

    if (Object.keys(uploadObj).length > 0) {
      uploadData(uploadObj);
    }
  };

  const handleClose = () => setShow(false);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  function goBack() {
    navigate('/shoppartner/view', { replace: true });
  }
  window.addEventListener('popstate', goBack);

  const onFinish1 = (values) => {
    console.log('values-->', values);

    console.log('values-->', values.invList);
    // if (!values.invList || values.invList.length < 0) {
    //   //  setShow(false);
    //   message.error('Kindly  Select atleast one Product');
    //   // return;
    // }
    const { invList } = values;
    console.log('invList-->', invList);

    const shopPartnerId = JSON.parse(localStorage.getItem('shopPartnerId'));
    // console.log('shopPartnerId-->', shopPartnerId?.shopPartnerId);

    // Map over invList to create the required payload format
    const payload = invList.map((item) => ({
      shopPartnerId: shopPartnerId?.shopPartnerId, // Use the shopPartnerId from localStorage
      productId: item.product, // Access the selected product ID
      commissionPercentage: item.commission,
      commissionPercentageClient: item.commissionPercentageClient,
    }));

    console.log('payload--->', payload);

    // TODO: Add API integration
    try {
      // if (!values.invList || values.invList.length < 0) {
      //   //  setShow(false);
      //   message.error('Kindly  Select atleast one Product');
      //   return;
      // }
      axios
        .post(`${app.URL}/api/v1/admin/shoppartnermapping/create`, payload, { headers: getHeaders() })
        .then((res) => {
          console.log(res);
          console.log('api-res-add-wali--->', res.data.result.data);
          setLoading(false);

          if (res.data.result.success) {
            setAPIResp(true); // Show new Select
            setApiUrl(res.data.result.data);
            setDummyData({ invList: res.data.result.data });
            message.success('Product Added Successfully!');
          } else {
            message.warning(res.data.result.msg);
          }
        })
        .catch((err) => {
          setLoading(false);
          message.warning('Error occurred. Please try again.');
          console.log(err);
        });
    } catch (err) {
      console.error('Unexpected error:', err);
    }
  };
  const onFinishFailed1 = (errorInfo) => {
    console.log('Failed:', errorInfo.values.invList);

    // Extract boxType values from the invList array
    const boxTypesToRemove = errorInfo?.values?.invList?.filter((item) => item.product !== undefined).map((item) => item.product);

    // Filter the main bocType array
    setProducts(prrds.filter((item) => !boxTypesToRemove.includes(item.productId)));
  };
  console.log('spiUrl--->', apiUrl);

  const handleRemove = (index, remove) => {
    // First, remove the item from the list (dummydata.invList)
    remove(index);

    // Update dummydata state correctly after removing an item
    const updatedDummyData = [...dummydata.invList];
    updatedDummyData.splice(index, 1);

    // Update the dummydata state with the modified list
    setDummyData((prevData) => ({
      ...prevData,
      invList: updatedDummyData,
    }));

    // Ensure that the URL associated with this index is removed from apiUrl
    // We need to shift the indexes properly after removal to make sure no other URL is affected.
    const updatedApiUrl = { ...apiUrl };
    // Delete the entry at the index that was removed from dummydata
    delete updatedApiUrl[index];

    // Shift the URLs for subsequent items to ensure they're correctly aligned with the updated list
    const updatedApiUrlShifted = {};
    Object.keys(updatedApiUrl).forEach((key) => {
      if (key > index) {
        updatedApiUrlShifted[key - 1] = updatedApiUrl[key]; // Shift keys left
      } else {
        updatedApiUrlShifted[key] = updatedApiUrl[key];
      }
    });

    // Update apiUrl state with the shifted URLs
    setApiUrl(updatedApiUrlShifted);
  };

  const getFilteredProducts = (index) => {
    return products.filter(
      (product) =>
        !selectedProducts.includes(product.productId) || // Exclude already selected values
        selectedProducts[index] === product.productId // Include the current dropdown's selected value
    );
  };

  // Handle product change
  const handleProductChange = (value, index) => {
    const updatedSelectedProducts = [...selectedProducts];
    updatedSelectedProducts[index] = value; // Update the value for the specific index
    setSelectedProducts(updatedSelectedProducts); // Update state
  };

  const handleKeyPress = (e) => {
    const inputValue = e.target.value; // Current input value
    const prospectiveValue = inputValue + e.key; // Simulate the new value if the key is added
    console.log('here in func');
    // Check if the input is numeric and within the range
    if (!/^\d$/.test(e.key)) {
      // Block non-numeric keys
      e.preventDefault();
      return;
    }

    if (Number(prospectiveValue) > 100) {
      // Prevent typing that exceeds the limit
      e.preventDefault();
      console.log(`Blocked input: ${prospectiveValue} exceeds 100`);
    }
  };

  console.log('shopPartnershopPartner', shopPartner);
  return (
    <div className='dashboard-card'>
      <UpdateRecord
        form={form}
        loading={loading}
        pageTitle='Update Affiliate'
        initialValues={{
          remember: true,
          ['email']: shopPartner?.email || '',
          ['address']: shopPartner?.address || '',
          ['phone']: shopPartner?.phone || '',
          ['affiliateName']: shopPartner?.affiliateName || '',
          ['contactName']: shopPartner?.contactName || '',
          ['callbackUrl']: shopPartner?.callbackUrl || '',
          ['isActive']: shopPartner?.isActive || '',
          ['clientId']: shopPartner?.clientId || '',
          ['parentId']: shopPartner?.name || '',
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        addUserResp={addUserResp}
        handleClose={handleClose}
        show={show}
        switchBtn={true}
        updateMessage='Are you sure you want to update Affiliate?'
        goBack={goBack}
        submitData={submitData}
        padding={true}
        response={shopPartObj}
        upload={false}
        inputs={[
          // <InputField
          //   name='parentId'
          //   required={true}
          //   placeholder='Parent Id '
          //   label='Parent Id '
          //   col='col-md-4 col-12'
          //   rules={[
          //     {
          //       required: true,
          //       message: 'Enter Parent Id ',
          //     },
          //   ]}
          // />,
          // <SelectField
          //   options={affiliateParents?.map((item) => (
          //     <Select.Option key={item.affiliateParentId} value={item.affiliateParentId}>
          //       {item.name}
          //     </Select.Option>
          //   ))}
          //   name='parentId'
          //   label='Patient Id'
          //   col='col-md-4 col-12'
          //   required={true}
          //   rules={[
          //     {
          //       required: false,
          //       message: 'Select patient',
          //     },
          //   ]}
          //   placeholder='Select patient'
          //   // value={initialValueaa} // Set initial value here
          //   // onChange={handleStatusChange} // Optionally handle the change
          // />,
          // correct
          // <SelectField
          //   // onChange={(e) => handleStatusChange(e)}
          //   options={affiliateParents?.map((item) => (
          //     <Select.Option key={item.parentId}>{item.name}</Select.Option>
          //   ))}
          //   name='parentId'
          //   label='Parent Id'
          //   disabled={true}
          //   col='col-md-4 col-12'
          //   required={true}
          //   rules={[
          //     {
          //       required: true,
          //       message: 'Select Parent Id',
          //     },
          //   ]}
          //   placeholder='Select Parent Id'
          // />,
          <InputField
            name='parentId'
            required={true}
            disabled={true}
            // placeholder='Client Id '
            label='Parent Id'
            col='col-md-4 col-12'
            rules={[
              {
                required: true,
                message: 'Enter Parent Id ',
              },
            ]}
          />,
          <InputField
            name='clientId'
            required={true}
            disabled={true}
            placeholder='Client Id '
            label='Client Id '
            col='col-md-4 col-12'
            rules={[
              {
                required: true,
                message: 'Enter Client Id ',
                validator: (_, value) => {
                  // Trim the value to remove spaces
                  const trimmedValue = value?.trim();

                  // Check if the trimmed value is empty
                  if (!trimmedValue) {
                    return Promise.reject('Client Id is required');
                  }

                  // If value exists, allow the validation to pass
                  return Promise.resolve();
                },
              },
            ]}
          />,

          <InputField
            name='affiliateName'
            required={true}
            placeholder='Affiliate Name'
            label='Affiliate Name'
            col='col-md-4 col-12'
            rules={[
              {
                required: true,
                message: 'Enter Affiliate Name',
                validator: (_, value) => {
                  // Trim the value to remove spaces
                  const trimmedValue = value?.trim();

                  // Check if the trimmed value is empty
                  if (!trimmedValue) {
                    return Promise.reject(' Affiliate Name is required');
                  }

                  // If value exists, allow the validation to pass
                  return Promise.resolve();
                },
              },
            ]}
          />,

          <InputField
            name='contactName'
            required={true}
            placeholder='Contact Name'
            label='Contact Name'
            col='col-md-4 col-12'
            rules={[
              {
                required: true,
                message: 'Enter Contact Name',
                validator: (_, value) => {
                  // Trim the value to remove spaces
                  const trimmedValue = value?.trim();

                  // Check if the trimmed value is empty
                  if (!trimmedValue) {
                    return Promise.reject('Contact Name is required');
                  }

                  // If value exists, allow the validation to pass
                  return Promise.resolve();
                },
              },
            ]}
          />,
          <InputField
            col='col-md-4 col-12'
            name='email'
            disabled={true}
            rules={[
              {
                required: true,
                message: 'Enter Email',
              },
              {
                type: 'email',
                message: 'Please enter a valid email address',
              },
            ]}
            placeholder='Email'
            label='Email'
            // required={true}/
          />,
          <InputField
            col='col-md-4 col-12'
            name='address'
            rules={[
              {
                required: true,
                message: 'Enter Address',
                validator: (_, value) => {
                  // Trim the value to remove spaces
                  const trimmedValue = value?.trim();

                  // Check if the trimmed value is empty
                  if (!trimmedValue) {
                    return Promise.reject('Address is required');
                  }

                  // If value exists, allow the validation to pass
                  return Promise.resolve();
                },
              },
            ]}
            placeholder='Address'
            label='Address'
            required={true}
          />,
          <InputField
            name='callbackUrl'
            required={true}
            placeholder='Url '
            label='Callback Url'
            col='col-md-4 col-12'
            rules={[
              {
                required: true,
                message: 'Enter Callback Url',
                validator: (_, value) => {
                  // Trim the value to remove spaces
                  const trimmedValue = value?.trim();

                  // Check if the trimmed value is empty
                  if (!trimmedValue) {
                    return Promise.reject('Callback Url is required');
                  }

                  // If value exists, allow the validation to pass
                  return Promise.resolve();
                },
              },
            ]}
          />,
        ]}
        inputMask={[
          <InputMasker
            name='phone'
            required={true}
            label='Mobile'
            placeholder='Mobile'
            col='col-md-4 col-12'
            rules={[
              {
                required: true,
                message: 'Enter Mobile',
              },
            ]}
            // handleChange={handleChange}
          />,
        ]}
      />
      {/* {alert && (
        <div className='pb-3 -mt-7 flex justify-center'>
          <Alert message={successMsg} type='success' showIcon />
        </div>
      )} */}
      <div>
        {dummydata && (
          <Form
            name='inventoryList'
            onFinishFailed={onFinishFailed1}
            onFinish={onFinish1}
            className='row p-5 px-3 pb-1'
            autoComplete='off'
            initialValues={dummydata} // Pass initialValues here

            // initialValues={dummydata} // Pass initialValues here
          >
            {console.log('dummydata', dummydata)}
            <div
              className='row w-100 mx-0 mb-3 align-items-center'
              style={{
                backgroundColor: '#ffffff', // White background for a clean look
                padding: '15px 20px', // Increased padding for better spacing
                borderRadius: '8px', // Slightly larger rounded corners
                fontSize: '16px', // Improved readability
                border: '1px solid #e0e0e0', // Subtle border for structure
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // Light shadow for depth
              }}
            >
              <div
                className='col-3 col-sm-2 col-md-2 font-weight-semibold text-center text-md-left'
                style={{ fontSize: '16px' }} // Adjusted font size
              >
                Product
              </div>
              <div
                className='col-2 col-sm-2 col-md-2 font-weight-semibold  text-center text-md-left'
                style={{ fontSize: '16px' }} // Adjusted font size
              >
                Parent Commission
              </div>
              <div
                className='col-2 col-sm-2 col-md-2 font-weight-semibold  text-center text-md-left'
                style={{ fontSize: '16px' }} // Adjusted font size
              >
                Client Commission
              </div>
              {/* <div
                className='col-3 col-sm-3 col-md-3 font-weight-semibold  text-center text-md-left'
                style={{ fontSize: '16px' }} // Adjusted font size
              >
                Commission (%)
              </div> */}
              {/* {apiResp ? (
                <>
                  // <div className='col-12 col-sm-3 col-md-3 font-weight-semibold text-center text-md-left' style={{ fontSize: '16px' }}>
                  //   URL
                  // </div>
                  // <div className='col-12 col-sm-1 col-md-3 font-weight-semibold  text-center text-md-left' style={{ fontSize: '16px' }}>
                  //   Action
                  // </div>
                </>
              ) : ( */}
              {/* <div className='col-4 col-sm-4 col-md-5 font-weight-semibold  text-center text-black ' style={{ fontSize: '16px' }}>
                Action
              </div> */}
              {/* )} */}
              
              <div className='col-12 col-sm-3 col-md-3 font-weight-semibold text-center text-md-left' style={{ fontSize: '16px' }}>
                URL               </div>
         
              <div className='col-12 col-sm-1 col-md-2 font-weight-semibold  text-center  ps-6' style={{ fontSize: '16px',marginLeft:'20px' }}>
             Action 
              </div>
            </div>
            {console.log('here dummy', dummydata)}
            <Form.List name='invList'>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, fieldKey, ...restField }, index) => (
                    <Space key={key} className='col-md-12 m-0' align='baseline' gap='13'>
                      <div className='row mx-0 w-100'>
                        <Form.Item
                          {...restField}
                          name={[name, 'product']}
                          className='col-2 px-0 col-sm-2 col-md-2'
                          rules={[
                            {
                              required: true,
                              message: 'Select a Product',
                            },
                          ]}
                        >
                          {/* {console.log('key', key, 'index', index)} */}

                          <Select disabled={index <= dummydata.invList.length - 1} placeholder='Select Product' style={{ marginBottom: '5px' }} onChange={(value) => handleProductChange(value, index)}>
                            {/* {products.map((item) => (
                              <Select.Option key={item.productId} value={item.productId}>
                                {item.name}
                              </Select.Option>
                            ))} */}
                            {getFilteredProducts(index).map((item) => (
                              <Select.Option key={item.productId} value={item.productId}>
                                {item.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'commission']}
                          className='col-2 px-0 col-sm-2 col-md-2 mx-1'
                          rules={[
                            {
                              required: true,

                              message: (
                                <p className=' nowrap' style={{ marginTop: '-30px', color: '#FF4D4F' }}>
                                  Enter Commission{' '}
                                </p>
                              ),
                            },
                            // {
                            //   validator: (_, value) => (value >= 0 && value <= 100 ? Promise.resolve() : Promise.reject('Commission must be between 0 and 100')),
                            // },
                          ]}
                        >
                          <InputField placeholder='Enter Parent Commission' type='text' onKeyPress={(e) => handleKeyPress(e)} />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'commissionPercentageClient']}
                          className='col-2 px-0 col-sm-2 col-md-2 mx-1'
                          rules={[
                            {
                              required: true,
                              message: (
                                <p className=' nowrap' style={{ marginTop: '-30px', color: '#FF4D4F' }}>
                                  Enter Commission{' '}
                                </p>
                              ),
                            },
                          ]}
                        >
                          <InputField
                            // name='commissionPercentageClient'
                            placeholder='Enter Client  Commission'
                            // label='Commission (%)'
                            min='0'
                            max='100'
                            type='text'
                            // onChange={(e)=>handleNumberChange(e)}
                            onKeyPress={(e) => handleKeyPress(e)}
                            className='col-12 px-0 col-sm-7 col-md-3'
                          />
                        </Form.Item>

                        {/* Show initial URL for existing data */}
                        {dummydata.invList[index]?.url && !apiUrl[index]?.url && (
                          // <div className='col-2 col-sm-2 col-md-3 px-0 px-md-2  mb-4 ' style={{ border: '1px solid red' }}>
                          //   <div className='border flex gap-1  items-center flex-nowrap flex-md-nowrap pb-3'>
                          //     {/* Display the first 50 characters of the URL */}
                          //     <div className='text-slate-500 w-75 pb-4  pt-2 flex-wrap  ' style={{ border: '1px solid red' }}>
                          //       <Tooltip title={dummydata.invList[index].url} className=''>
                          //         {dummydata.invList[index].url.slice(0, 30)}...
                          //       </Tooltip>
                          //     </div>
                          //     <div style={{ border: '1px solid red' }}>
                          //       {/* Copy to Clipboard Button */}
                          //       <button
                          //         onClick={(e) => {
                          //           e.preventDefault();
                          //           navigator.clipboard.writeText(dummydata.invList[index].url);
                          //           message.success('URL copied to clipboard!');
                          //         }}
                          //         className='btn btn-primary mb-2   '
                          //         style={{ whiteSpace: 'nowrap', border: '1px solid red' }}
                          //       >
                          //         Copy
                          //       </button>{' '}
                          //     </div>
                          //   </div>
                          // </div>

                          <div className='col-2 col-sm-2 col-md-3 px-0   mb-4 '>
                            <div className=' flex gap-1 gap-md-4  items-center flex-nowrap flex-md-nowrap pb-3'>
                              {/* Display the first 50 characters of the URL */}
                              <div className='text-slate-500 w-75 pb-4  pt-2 flex-wrap  '>
                                <Tooltip title={dummydata.invList[index].url} className=''>
                                  {dummydata.invList[index].url.slice(0, 30)}...
                                </Tooltip>
                              </div>
                              <div className=''>
                                {/* Copy to Clipboard Button */}
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    navigator.clipboard.writeText(dummydata.invList[index].url);
                                    message.success('URL copied to clipboard!');
                                  }}
                                  className='btn btn-primary mb-2   '
                                  style={{ whiteSpace: 'nowrap' }}
                                >
                                  Copy Url
                                </button>{' '}
                              </div>
                            </div>
                          </div>
                        )}
                        {/* Show URL from API response when a new entry is added */}
                        {apiUrl[index]?.url && (
                          // <div className='col-12 col-md-6 px-0 px-md-2'>
                          //   <div className='flex gap-2 gap-md-5 items-center flex-wrap flex-md-nowrap pb-3'>
                          //     {/* Display the first 50 characters of the URL */}
                          //     <div className='text-slate-500 w-75'>{apiUrl[index].url}</div>

                          //     {/* Copy to Clipboard Button */}
                          //     <button
                          //       onClick={(e) => {
                          //         e.preventDefault();
                          //         navigator.clipboard.writeText(apiUrl[index].url);
                          //         message.success('URL copied to clipboard!');
                          //       }}
                          //       className='btn btn-primary mb-2 mb-sm-0'
                          //     >
                          //       Copy URL
                          //     </button>
                          //   </div>
                          // </div>
                          <div className='col-2 col-sm-2 col-md-3 px-0 px-md-2  mb-4 '>
                            <div className=' flex gap-1 gap-md-4  items-center flex-nowrap flex-md-nowrap pb-3'>
                              {/* Display the first 50 characters of the URL */}
                              <div className='text-slate-500 w-75 pb-4  pt-2 flex-wrap  '>
                                <Tooltip title={apiUrl[index].url} className=''>
                                  {apiUrl[index].url.slice(0, 30)}...
                                </Tooltip>
                              </div>
                              <div className=''>
                                {/* Copy to Clipboard Button */}
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    navigator.clipboard.writeText(dummydata.invList[index].url);
                                    message.success('URL copied to clipboard!');
                                  }}
                                  className='btn btn-primary mb-2   '
                                  style={{ whiteSpace: 'nowrap' }}
                                >
                                  Copy Url
                                </button>{' '}
                              </div>
                            </div>
                          </div>
                        )}
                        <span
                          className='col-1 col-md-2 ms-2'
                          style={{
                            fontSize: '1rem',
                            color: 'red',
                            paddingTop: '0.5rem',
                            // border: '1px solid red',
                            paddingLeft: '60px',
                          }}
                        >
                          <MinusCircleOutlined
                            onClick={() => {
                              console.log('fields', fields, 'length', fields.length, name, index);
                              if (fields.length > 1) {
                                handleRemove(index, remove);
                              }
                            }}
                          />
                        </span>
                      </div>
                    </Space>
                  ))}
                  <div
                    className=' '
                    style={{
                      // border: '1px solid red',
                      marginTop: '1.8px',
                      marginLeft: '4px',
                    }}
                  >
                    <button
                      // disabled={apiResp}
                      onClick={() => {
                        // handleAdd;
                        add();
                        setNoinvList(false);
                      }}
                      type='primary'
                      className={`btn btn-primary button px-6  ${noinvList ? 'mb-1' : 'mb-4'}`}
                    >
                      Add
                    </button>
                  </div>
                </>
              )}
            </Form.List>
            <div>
              <button type='primary' className='btn btn-primary button col-md-2 mb-2' htmlType='submit'>
                Submit
              </button>
            </div>
          </Form>
        )}
      </div>
    </div>
  );
};;;

export default EditShopPartner;
